<div class="flex w-full min-h-0 flex-col" tabindex="-1">
  @if (this.appNotificationService.initialLoading()) {
    <div class="flex-center my-20 pb-[2px] py-[1px] w-full">
      <span
        class="loading loading-spinner loading-lg"
        role="status"
        aria-hidden="true"
      ></span>
    </div>
  } @else {
    <div class="flex min-h-0 flex-1 flex-col">
      <!-- tabs header -->

      <app-tab-group [tabs]="tabs()" [(activeTab)]="activeTab"> </app-tab-group>
      <!-- tabs content -->
      <div class="mt-2 flex min-h-0 flex-1 flex-col" tabindex="-1">
        <!-- unread messages content -->
        @if (activeTab === "unreadMessages") {
          <div
            class="px-5 min-h-0 flex-1 overflow-y-auto"
            appInfiniteScroll
            tabindex="-1"
            [distance]="'10%'"
            [debounceTime]="150"
            [disabled]="loading || reachedEnd"
            (scrolled)="onScrollDown()"
          >
            @for (
              item of appNotificationService.unreadNotifications();
              track item.notificationId
            ) {
              <notification-item
                [notification]="item"
                (updateNotifications)="refreshNotifications()"
              ></notification-item>
            } @empty {
              <div class="w-full my-20 opacity-40">
                <h3 class="text-center text-[18px] text-muted-foreground">
                  {{ "common.empty" | translate }}
                </h3>
              </div>
            }

            @if (loading) {
              <div class="flex-center my-4">
                <span class="loading loading-spinner loading-sm"></span>
              </div>
            }
          </div>
        }

        <!-- all messages content -->
        @if (activeTab === "allMessages") {
          <div
            class="px-5 min-h-0 flex-1 overflow-y-auto"
            appInfiniteScroll
            tabindex="-1"
            [distance]="'10%'"
            [debounceTime]="150"
            [disabled]="loading || reachedEnd"
            (scrolled)="onScrollDown()"
          >
            @for (
              item of appNotificationService.allNotifications();
              track item.notificationId
            ) {
              <notification-item
                [notification]="item"
                (updateNotifications)="refreshNotifications()"
              ></notification-item>
            } @empty {
              <div class="w-full my-20 opacity-40">
                <h3 class="text-center text-[18px] text-muted-foreground">
                  {{ "common.empty" | translate }}
                </h3>
              </div>
            }

            @if (loading) {
              <div class="flex-center my-4">
                <span class="loading loading-spinner loading-sm"></span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
